module.exports = __webpack_public_path__ + "img/csr_111123_G.88dbea27.jpg";